import { TypePolicies } from '@apollo/client';
import SwapTypePolicy from './Swap';
import BasicContractTypePolicy from './BasicContract';
import SubscriptionDetailsTypePolicy from './SubscriptionDetails';

const typePolicies: TypePolicies = {
    MixSummary: {
        keyFields: ['contractId'],
    },
    MixCartOrder: {
        keyFields: ['orderNumber'],
    },
    [SwapTypePolicy.type]: SwapTypePolicy.policy,
    [BasicContractTypePolicy.type]: BasicContractTypePolicy.policy,
    [SubscriptionDetailsTypePolicy.type]: SubscriptionDetailsTypePolicy.policy,
};

export default typePolicies;
